import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Button from '@mui/material/Button';

const theme = createTheme({
  palette: {
    primary: {
      main: "#002c6aff",
    },
    secondary: {
      main: '#11cb5f',
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          // backgroundColor: "#bad7ff",
        }
      }
    },
    MuiListSubheader: {
      styleOverrides: {
        // Name of the slot
        root: {
          backgroundColor: "#002c6aff",
          color: "var(--font-color)"
        }
      }
    },
    // Name of the component
    MuiListItem: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          // backgroundColor: 'var(--color-bg)',
          cursor: 'pointer',

          "&:hover": {
            // backgroundColor: "#73aeff",
          },
        },
      },
    },
  },
});

export default theme